import styled from "styled-components";
import { Grid, Card } from "semantic-ui-react";
import { Svg } from "../../../assets";
import { theme } from "../../../styling/theme";

const defaultImage = Svg.PromptPlaceholder;

const thumbnailSize = (thumbnail?: string): string => {
  if (thumbnail) {
    return `url("${thumbnail}") no-repeat center center`;
  }

  return `url(${defaultImage}) no-repeat center center`;
};
export const PromptCardStyle = styled(Card)({
  background: `${theme.lightBackgroundColor} !important`,
  borderRadius: "6.3px !important",
  border: `1px solid ${theme.boxLightBorder} !important`,
  boxShadow: `none !important`,
  width: "150px !important",
  margin: " 0 12px !important",
  display: "inline-block",
});

export const CampaignCardContent = styled(Card.Content)({
  padding: "10px !important",
});

export const PromptHeader = styled(PromptCardStyle.Header)({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
});
export const ThumbnailPreview = styled(Grid.Column)`
  width: 100%;
  height: 125px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background: ${(props: any) => thumbnailSize(props.thumbnailurl)};
  background-size: ${(props: any) => (props.thumbnailurl ? "cover" : "inherit")};
  background-color: #eaeaf0;
`;
export const EnrroledLabel = styled.span`
  color: ${theme.buttonColor};
  display: block;
`;
